import { render, staticRenderFns } from "./ActivityCategories.vue?vue&type=template&id=d3989fa0&scoped=true&"
import script from "./ActivityCategories.vue?vue&type=script&lang=js&"
export * from "./ActivityCategories.vue?vue&type=script&lang=js&"
import style0 from "./ActivityCategories.vue?vue&type=style&index=0&id=d3989fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3989fa0",
  null
  
)

export default component.exports